import { render, staticRenderFns } from "./dateTabCom.vue?vue&type=template&id=798ba4b8&scoped=true&"
import script from "./dateTabCom.vue?vue&type=script&lang=js&"
export * from "./dateTabCom.vue?vue&type=script&lang=js&"
import style0 from "./dateTabCom.vue?vue&type=style&index=0&id=798ba4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ba4b8",
  null
  
)

export default component.exports